import { useState } from "react";
import { useAccessibility } from "../../providers/accessibility-hooks";
import { MobileContainer } from "./style";
import { ActionsContainer } from "./ActionsContainer";
import { MainButton } from "./MainButton";
import { useToggleVLibras } from "./hooks/toggle-libras";

export const MobileAccessibilityButtons = () => {
  const { increaseFonts, decreaseFonts, toggleContrast } = useAccessibility();
  const [open, setOpen] = useState(false);
  const { toggleVLibras } = useToggleVLibras();

  const handleActionClick = (action: () => void) => {
    action();
  };

  return (
    <MobileContainer id="accessibility-buttons">
      {open && (
        <ActionsContainer
          increaseFonts={increaseFonts}
          decreaseFonts={decreaseFonts}
          toggleContrast={toggleContrast}
          handleToggleVLibras={toggleVLibras}
          onActionClick={handleActionClick}
          variant="mobile"
        />
      )}
      <MainButton onClick={() => setOpen((prev) => !prev)} isOpen={open} />
    </MobileContainer>
  );
};
